import { render, staticRenderFns } from "./impresionDXComponent.vue?vue&type=template&id=915ce200"
import script from "./impresionDXComponent.vue?vue&type=script&lang=js"
export * from "./impresionDXComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports